import { useId } from "react";

import { formatarStatusFinanceiro } from "@/modules/financeiro-obras";
import type {
  FinanceiroStatusTagProps,
  FinanceiroStatusTagViewModel,
} from "./types-financeiro-status-tag";

/** Tag do status financeiro: sigla abreviada e tooltip com o nome completo. */
export function useFinanceiroStatusTag({
  status,
  testId,
  className,
}: FinanceiroStatusTagProps): FinanceiroStatusTagViewModel {
  const escopo = useId();

  return {
    isEmpty: status === null,
    label: status ? formatarStatusFinanceiro(status, { abreviado: true }) : "",
    tooltip: status ? formatarStatusFinanceiro(status) : "",
    escopo,
    tooltipTarget: `[data-financeiro-status="${escopo}"]`,
    testId,
    className,
  };
}
